/**
 * 复制粘贴
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import {Divider,message,  } from 'antd';
import {isEmpty,trim} from '@utils/utils';
import Lang from "@components/Lang/Lang";
import PropTypes from "prop-types";
import "./Index.less";


class CopyAndPaste extends React.Component{
    static propTypes ={
        optionId:PropTypes.string.isRequired,
        pasteRes: PropTypes.func.isRequired,
    }
    static defaultProps = {
        optionId:'',

    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        }
    }
    /**
     * 复制动作
     ***/
    handleCopy(inputId=''){
        let agent = document.getElementById(inputId);
            agent.select();
        document.execCommand("Copy"); // 执行浏览器复制命令
    }
    /**
     * 粘贴动作
     * */
    async handlePaste(inputId) {
        // 查看当时是否有权限
        navigator.permissions.query({
            name:'clipboard-read'
        }).then((permissionsStatus)=>{
            // console.log('permissionsStatus',permissionsStatus)
            if(permissionsStatus.state=='granted'){ //有权限
               navigator.clipboard.readText().then((resStatus)=>{
                   this.props.pasteRes(trim(resStatus));
                });
            }else if(permissionsStatus.state=='prompt'){ //询问权限
                // message.info(Lang({
                //     id:'QingYunXuLiuLanQiJianTieBanQuanXian',
                //     default:'请允许浏览器剪贴板权限'})
                // )
                navigator.clipboard.readText().then((resStatus)=>{
                    this.props.pasteRes(trim(resStatus));
                });
            }else { //禁止状态
                const agent = document.getElementById(inputId);
                agent.focus();
                message.info(Lang({
                    id:'DangQianLiuLanQiBuZhiChiZhanTieHangWei,QingShiYong ctrl+v',
                    default:'当前浏览器不支持粘贴行为,请使用ctrl+v'})
                )
            }
        })
    }
    componentDidMount() {
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const { optionId } =this.props;
        return (<div className={'copyAndPaste'}>
                <span onClick={()=>this.handleCopy(optionId)}>{Lang({id: "FuZhi",default: "复制"})}</span>
                <Divider type="vertical" />
                <span onClick={(e)=>this.handlePaste(optionId)}>{Lang({id: "ZhanTie",default: "粘贴"})}</span>
        </div>)
    }
}

export default CopyAndPaste;
